import { IBannerReponse } from "../../../model/base/response/banner-response";
import { ICategoryPublicationResponse } from "../../../model/base/response/category-publication-response";
import { IGroupedBidsYearResponse } from "../../../model/base/response/grouped-bids-year-response";
import { IGroupedDailyOfficialResponse } from "../../../model/base/response/grouped-daily-official-response";
import { IGroupedPublicAccountBySubCategoryResponse } from "../../../model/base/response/grouped-public-account-subcategory-response";
import { IManagementUnitResponse } from "../../../model/base/response/management-unit-response";
import { IMenuResponse } from "../../../model/base/response/menu-response";
import { INewsReponse } from "../../../model/base/response/news-response";
import { IPublicAccountResponse } from "../../../model/base/response/public-account-response";
import { ISubcategoryPublicationResponse } from "../../../model/base/response/subcategory-publication-response";
import { Pagination } from "../../../model/paginatiion";


export type PublicAccountState = {
  publicAccount: Pagination<IPublicAccountResponse>;
  category: ICategoryPublicationResponse;
  subcategory: ISubcategoryPublicationResponse;
  categories: ICategoryPublicationResponse[];
  subcategories: ISubcategoryPublicationResponse[];
};

export enum ACTION_TYPES {
  loadingData = 'loadingData',
  clearData = 'clearData',
  setCategoryPublication = 'setCategoryPublication',
  setSubcategoryPublication = 'setSubcategoryPublication',
  setCategoriesPublication = 'setCategoriesPublication',
  setSubcategoriesPublication = 'setSubcategoriesPublication',
}

export const PublicAccountReducer = (state: PublicAccountState, action: any): PublicAccountState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.loadingData:
      return {
        ...state,
        publicAccount: payload,
      };
    case ACTION_TYPES.clearData:
      return {
        ...state,
        publicAccount: {} as Pagination<IPublicAccountResponse>,
      };
    case ACTION_TYPES.setCategoryPublication:
      return {
        ...state,
        category: payload,
      };
    case ACTION_TYPES.setSubcategoryPublication:
      return {
        ...state,
        subcategory: payload,
      };
    case ACTION_TYPES.setCategoriesPublication:
      return {
        ...state,
        categories: payload,
      };
    case ACTION_TYPES.setSubcategoriesPublication:
      return {
        ...state,
        subcategories: payload,
      };

    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}